<script>
  import solicitacaoPagamentoServico from '../../servico';
  import Cabecalho from '~componentes/CabecalhoRelatorio.vue';
  import formasPagamento from '~js/formas-pagamento';
  import tiposPagamento from '~js/tipos-pagamento';
  import tiposConta from '~js/tipos-conta';
  import tiposQuadro from '~js/tipos-quadro';
  import Barcode from '@xkeshi/vue-barcode';
  import converterNumero from '~js/converter-moeda';

  export default {
    components: { Cabecalho, Barcode },
    data() {
      return {
        solicitacao: {},
        carregando: true,
        formasPagamento: formasPagamento,
        tiposPagamento: tiposPagamento,
        tiposConta: tiposConta,
        tiposQuadro: tiposQuadro,
        configuracao: this.$storage.configuracao(),
      }
    },
    methods: {
      carregar: function(id) {
        this.carregando = true;

        solicitacaoPagamentoServico
          .obterPorId(id)
          .then(solicitacao => {
            this.carregando = false;
            this.solicitacao = solicitacao;
          });
      },
      formaPagamento(id) {
        return this.formasPagamento.find(f => {
          return f.id === id;
        });
      },
      tipoPagamento(id) {
        return this.tiposPagamento.find(t => {
          return t.id === id;
        });
      },
      tipoConta(id) {
        return this.tiposConta.find(t => {
          return t.id === id;
        });
      },
      tipoQuadro(id) {
        return this.tiposQuadro.find(t => {
          return t.id === id;
        });
      },
    },
    computed: {
      dataLiberacaoCoordenador() {
        return this.$options.filters.formatarNumeroEmDataExtenso(this.solicitacao.solicitacao.liberacaoCoordenador) || '---';
      },
      retornaValorSolicitacao() {
        let total = 0;
        
        total += this.solicitacao.solicitacaoPagamentoRateio.reduce((somatorio, rateio) => {
          return somatorio + converterNumero.paraDolar(rateio.valorRateio);
        }, 0);

        return total;
      }
    },
    created() {
      this.carregar(this.$route.params.id);
    },
    mounted() {
      this.$root.tituloDaPagina = 'Solicitação de Pagamento de Pessoa Jurídica (Rateio) - Relatório';
      this.$root.botaoAcaoTexto = 'Imprimir relatório';
      this.$root.botaoAcaoIcon = 'fa-print';
      this.$root.botaoAcaoLink = '';
      this.$root.filtrosBag = this.$route.params.filtrosBag;

      this.$root.botaoRetrocederMostrar = true;

      if (this.$route.params.rota)
        this.$root.botaoRetrocederRota = this.$route.params.rota
      else
        this.$root.botaoRetrocederRota = 'solicitacao-pagamento-rateio-pj';

      this.$events.on('botaoAcao', function() {
        window.print();
      });
    },
    beforeDestroy() {
      this.$events.off('botaoAcao');
    }
  }
</script>

<template>
  <div>
    <div :class="'wrapper wrapper-content animated ' + $root.animacaoPadrao" id="relatorio">
      <div class="row">
        <div class="col-lg-12">
          <div class="ibox float-e-margins">
            <div class="ibox-content">
              
              <p v-show="carregando" class="text-center">
                <i class='fa fa-spinner fa-pulse'></i> Carregando...
              </p>

              <div v-if="!carregando">
                <cabecalho :titulo="'Solicitação de Pagamento de Pessoa Jurídica'"></cabecalho>

                <h3 class="m-t-none m-b">Dados da solicitação</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.idSolicitacao || '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Data da solicitação</dt>
                    <dd>{{ solicitacao.solicitacao.dataSolicitacao | formatarNumeroEmDataExtenso }}</dd>
                  </dl>
                  <dl class="col-xs-3">
                    <dt>Solicitante</dt>
                    <dd>{{ solicitacao.solicitacao.solicitante ? solicitacao.solicitacao.solicitante.nomePessoaFisicaJuridica : '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                    <dt>Data de liberação do coordenador</dt>
                    <dd>{{ dataLiberacaoCoordenador }}</dd>
                  </dl>
                  <dl :class="[configuracao.criarProtocoloSolicitacao ? 'col-xs-3' : 'col-xs-6']">
                    <dt>Liberado por</dt>
                    <dd>{{ solicitacao.solicitacao.liberadoPor ? solicitacao.solicitacao.liberadoPor.nomePessoaFisicaJuridica : '---' }}</dd>
                  </dl>
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.solicitacao.protocolo != null">
                    <dt>Nº protocolo</dt>
                    <dd>{{ solicitacao.solicitacao.protocolo ? solicitacao.solicitacao.protocolo.numeroProtocolo : '---'}}</dd>
                  </dl>
                  <dl class="col-xs-3" v-if="configuracao.criarProtocoloSolicitacao && solicitacao.solicitacao.protocolo != null">
                    <dt>Código de barras protocolo</dt>
                    <dd><barcode :value="solicitacao.solicitacao.protocolo.numeroProtocolo" :options="{ displayValue: false, height: 20, margin: 1 }"></barcode></dd>
                  </dl>
                </div>

                <div class="row" v-if="configuracao.selecaoDeContaWeb">
                  <dl class="col-xs-12">
                    <dt>Conta</dt>
                    <dd>{{ solicitacao.conta ? solicitacao.conta.nome : '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t-none m-b">Dados cadastrais</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-xs-8">
                    <dt>Nome</dt>
                    <dd>{{ solicitacao.solicitacao.nomeTerceiro || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>CNPJ</dt>
                    <dd>{{ solicitacao.solicitacao.documentoTerceiro || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Inscrição estadual</dt>
                    <dd>{{ solicitacao.solicitacao.identidade || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-6">
                    <dt>Inscrição municipal</dt>
                    <dd>{{ solicitacao.solicitacao.inscricaoMunicipal || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-6">
                    <dt>Endereço</dt>
                    <dd>{{ solicitacao.solicitacao.endereco || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Número</dt>
                    <dd>{{ solicitacao.solicitacao.numero || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Complemento</dt>
                    <dd>{{ solicitacao.solicitacao.complemento || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Bairro</dt>
                    <dd>{{ solicitacao.solicitacao.bairro || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Cidade</dt>
                    <dd>{{ solicitacao.solicitacao.cidade || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Estado</dt>
                    <dd>{{ solicitacao.solicitacao.uf || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>CEP</dt>
                    <dd>{{ solicitacao.solicitacao.cep || '---' }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-3">
                    <dt>Telefone 1</dt>
                    <dd>{{ solicitacao.solicitacao.telefoneResidencial || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Telefone 2</dt>
                    <dd>{{ solicitacao.solicitacao.telefoneComercial || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>Fax</dt>
                    <dd>{{ solicitacao.solicitacao.fax || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-3">
                    <dt>E-mail do beneficiário</dt>
                    <dd>{{ solicitacao.solicitacao.emailTerceiro || '---' }}</dd>
                  </dl>
                </div>

                <h3 class="m-t-none m-b">Dados para o pagamento</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="row">
                  <dl class="col-lg-3" v-if="configuracao.exibirDataPgtoSolicitacaoPgto">
                    <dt>Data para pagamento</dt>
                    <dd>{{ solicitacao.solicitacao.dataPagamento | formatarNumeroEmData }}</dd>
                  </dl>

                  <dl :class="[configuracao.exibirDataPgtoSolicitacaoPgto ? 'col-lg-3' : 'col-lg-4']">
                    <dt>Forma de pagamento</dt>
                    <dd>{{ formaPagamento(solicitacao.solicitacao.formaPagamento).nome }}</dd>
                  </dl>

                  <dl :class="[configuracao.exibirDataPgtoSolicitacaoPgto ? 'col-lg-3' : 'col-lg-4']">
                    <dt>Tipo pagamento</dt>
                    <dd>{{ tipoPagamento(solicitacao.solicitacao.tipoPagamento).nome }}</dd>
                  </dl>

                  <dl :class="[configuracao.exibirDataPgtoSolicitacaoPgto ? 'col-lg-3' : 'col-lg-4']">
                    <dt>Valor (R$)</dt>
                    <dd>{{ retornaValorSolicitacao | formatarNumero }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-4">
                    <dt>Nota fiscal</dt>
                    <dd>{{ solicitacao.solicitacao.notaFiscal || '---' }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Data de emissão</dt>
                    <dd>{{ solicitacao.solicitacao.dataEmissao | formatarNumeroEmData('---') }}</dd>
                  </dl>

                  <dl class="col-xs-4">
                    <dt>Data de vencimento</dt>
                    <dd>{{ solicitacao.solicitacao.dataVencimento | formatarNumeroEmData('---') }}</dd>
                  </dl>
                </div>

                <div class="row">
                  <dl class="col-xs-12">
                    <dt>Atividade/descrição serviços</dt>
                    <dd class="white-space-pre">{{ solicitacao.solicitacao.observacao || '---' }}</dd>
                  </dl>
                </div>

                <div v-if="solicitacao.formaPagamento === 0">
                  <h3 class="m-t-none m-b">Dados bancários</h3>

                  <div class="hr-line-dashed margin-top-5"></div>

                  <div class="row">
                    <dl class="col-xs-3">
                      <dt>Banco</dt>
                      <dd>{{ solicitacao.solicitacao.banco || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-3">
                      <dt>Agência</dt>
                      <dd>{{ solicitacao.solicitacao.agencia || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-3">
                      <dt>Conta</dt>
                      <dd>{{ solicitacao.solicitacao.contaCorrente || '---' }}</dd>
                    </dl>

                    <dl class="col-xs-3">
                      <dt>Tipo de conta</dt>
                      <dd>{{ tipoConta(solicitacao.solicitacao.tipoConta).nome }}</dd>
                    </dl>
                  </div>
                </div>

                <h3 class="m-t-none m-b">Projetos</h3>

                <div class="hr-line-dashed margin-top-5"></div>

                <div class="bs-callout bs-callout-info no-margin-top" v-for="(rateio, index) in solicitacao.solicitacaoPagamentoRateio">
                  <div class="row">
                    <dl :class="[rateio.projetoMetaEtapa != null ? 'col-xs-4' : 'col-xs-6']">
                      <dt>Projeto</dt>
                      <dd>{{ rateio.projeto ? rateio.projeto.nomeProjeto : ''}}</dd>
                    </dl>

                    <dl class="col-xs-2">
                      <dt>Tipo de projeto</dt>
                      <dd>{{ rateio.projeto.tipoProjeto ? rateio.projeto.tipoProjeto.nome : '---' }}</dd>
                    </dl>

                    <dl class="col-xs-2">
                      <dt>Coordenador do projeto</dt>
                      <dd>{{ rateio.projeto.coordenador ? rateio.projeto.coordenador.nomePessoaFisicaJuridica : '---' }}</dd>
                    </dl>

                    <dl class="col-xs-2" v-if="rateio.projetoMetaEtapa != null">
                      <dt>Meta Etapa</dt>
                      <dd>{{ rateio.projetoMetaEtapa.meta ? rateio.projetoMetaEtapa.meta.nome : '' }} - {{ rateio.projetoMetaEtapa.etapa ? rateio.projetoMetaEtapa.etapa.nome : ''}}</dd>
                    </dl>

                    <dl class="col-xs-2">
                      <dt>Valor (R$)</dt>
                      <dd>{{ rateio.valorRateio || '---' }}</dd>
                    </dl>
                  </div>
                </div>

                <div class="bs-callout bs-callout-primary" v-if="configuracao.utilizarValorEstimado">
                  <h4>Valor total: R$ {{ retornaValorSolicitacao | formatarNumero }}</h4>
                </div>

              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-pagamento-rateio/juridica/componentes/SolicitacaoPagamentoRelatorio.vue